import React from "react";
import { api } from "../../api/api";
import { IInsurerCode } from "../../redux/insurer/insurer.types";
import { ISelectOption } from "../../constants/types";
import { ExtendableSelect } from "../formsComponents/ExtendableSelect";

interface IInsurerDropdownProps {
  value: string | null;
  onChange: (data: ISelectOption) => void;
  error?: boolean;
  errorMessage?: string;
  disabled?: boolean;
  fullWidth?: boolean;
  placeholder?: string;
}

export const InsurerDropdown: React.FC<IInsurerDropdownProps> = ({
  value,
  onChange,
  error,
  errorMessage,
  disabled,
  fullWidth,
  placeholder,
}) => {
  const [state, setState] = React.useState<ISelectOption[]>([]);

  const handleSelectChange = (newValue: string) => {
    if(!newValue){
        onChange({label: "", value: ""});
        return;
    }
   
    const item = state.find((x) => x.value === newValue);
    if (item) {
      onChange(item);
    } else {
      onChange({ label: newValue.toString(), value: newValue });
    }
  };

  const fetchInsurers = async () => {
    try {
      const res = await api.get(`/insurance/get-insurer-code?status=ACTIVE`);
      const data: IInsurerCode[] = res.data.data;
      const finalData: ISelectOption[] = [];
      for (const insurer of data) {
        if (insurer.insurer_code) {
          finalData.push({
            label: `${insurer.insurer_code} (${insurer.name})`,
            value: insurer.insurer_code,
          });
        }
      }
      setState(finalData);
    } catch (error) {
      console.error("Error fetching data:", error);
    }
  };

  React.useEffect(() => {
    fetchInsurers();
  }, []);

  return (
    <>
      <ExtendableSelect
        value={value}
        onChange={handleSelectChange}
        options={state}
        error={error}
        errorMessage={errorMessage}
        disabled={disabled}
        fullWidth={fullWidth}
        placeholder={placeholder}
      />
    </>
  );
};
